import axiosInstance from "./api";

export const checkoutService = {
  getConsecutive: () => axiosInstance.get("score/consecutive/1"),
  getShowtimeData: (showtimeId) => axiosInstance.get(`room/${showtimeId}`),
  getShowtimeStatus: (showtimeId) =>
    axiosInstance.get(`room/${showtimeId}/status`),
  getConfectioneries: () => axiosInstance.get("confectioneries/score/viziona"),
  getConfectioneriesApi: () => axiosInstance.get("confectioneries"),
  getPayBrands: () => axiosInstance.get("pay-brands"),
  reserve: (showtimeId, data) =>
    axiosInstance.post(`reserve/${showtimeId}`, data),
  cancelReserve: (showtimeId, data) =>
    axiosInstance.post(`reserve/cancel/${showtimeId}`, data),
};
